import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, Button, App, Flex, Grid } from "antd";
import { PrinterOutlined, ArrowLeftOutlined, DownloadOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import { setCurrentRoute } from "../../../store/commonSlices/routeSlice";
import CreditorPaymentRecordTable from "./components/CreditorPaymentRecordTable";
import CreditorPaymentRecordFilters from "./components/CreditorPaymentRecordFilters";
import CreditorPaymentRecordPrint from "./components/CreditorPaymentRecordPrint";
import { exportCreditorPaymentRecordCsv } from "./components/exportCreditorPaymentRecordCsv";


const CreditorPaymentRecord = ({ location }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { filters, list, loading } = useSelector((state) => state.creditorPaymentRecord);
  const lookups = useSelector((state) => state.lookups);
  const { useBreakpoint } = Grid;
  const screens   = useBreakpoint();
  // Get selected supplier details for print
  const selectedSupplier = filters.supplierId 
    ? lookups.customers.find(c => c.acc_id === filters.supplierId)
    : null;

  const handleNavigateToReports = () => {
    navigate("/reports");
  };

  const reportRef = useRef();
  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Creditor/Supplier Payment Record",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportCreditorPaymentRecordCsv({
      list,
      filters,
      title:    "Creditor/Supplier Payment Record",
      filename: "creditor_payment_record",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button 
                type="text" 
                icon={<ArrowLeftOutlined />} 
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />
              <span>Creditor/Supplier Payment Record</span>
            </div>
          }
          extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button
                type="primary"
                icon={<PrinterOutlined />}
                onClick={handlePrint}
                disabled={!hasData}
              >
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <CreditorPaymentRecordFilters messageApi={message} />
        
        <Card className="shadow-md rounded-xl">
          <CreditorPaymentRecordTable />
        </Card>
      </App>
      
      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <CreditorPaymentRecordPrint 
          ref={reportRef}
          filters={filters}
          selectedSupplier={selectedSupplier}
        />
      </div>
    </div>
  );
};

export default CreditorPaymentRecord;